import React from 'react';

export const VisuallyHidden = ({ children }: {children: React.ReactNode}) => (
    <span className="sr-only">{children}</span>
);
